import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linebreaks'
})
export class LinebreaksPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value.replace(/\n/g, '<br>');
  }

}
